module.exports = __webpack_public_path__ + "img/revolut.3b259d0f.png";